export interface SpringAttributes {
  stiffness: number; // N/mm
  stroke: number; // mm
  maxLoad: number; // N
  energyDensity: number; // J/mm^3
  mass: number; // kg
}

export function computeSpringAttributes(config: {
  thickness: number; // mm
  diameter: number; // cm
  springIndex: number; // coils
  length: number; // cm
}): SpringAttributes {
  const d = config.thickness; // mm
  const D = config.diameter * 10; // convert cm -> mm
  const n = config.springIndex;
  const L0 = config.length * 10; // cm -> mm
  const G = 79300; // shear modulus MPa ~ 79.3 GPa -> N/mm^2
  const rho = 7.85e-6; // kg/mm^3

  const k = (G * Math.pow(d, 4)) / (8 * n * Math.pow(D, 3));

  const Lsolid = n * d;
  const stroke = Math.max(L0 - Lsolid, 0);

  const C = D / d;
  const Ks = (4 * C - 1) / (4 * C - 4) + 0.615 / C;
  const tauAllow = 0.7 * 550; // MPa approximate yield
  const Fmaterial = (tauAllow * Math.PI * Math.pow(d, 3)) / (8 * Ks * D);
  const Fgeom = k * stroke;
  const maxLoad = Math.min(Fmaterial, Fgeom);

  const coilLength = Math.PI * D * n;
  const volume = (Math.PI * Math.pow(d, 2)) / 4 * coilLength; // mm^3
  const mass = volume * rho;
  const energyDensity = 0.5 * k * Math.pow(stroke, 2) / volume; // N*mm/mm^3

  return { stiffness: k, stroke, maxLoad, energyDensity, mass };
}
